/**
 * Kaydedilmemiş değişiklik (G4-13): kullanıcının değiştirdiği alan var mı. React Hook Form'un
 * `isDirty`'si bütün değer ağacını varsayılanla karşılaştırır; kaydedilmiş rapor sunucudan boş
 * alanları atılmış gelir, form ise kayıtlı alanları (`draft: {}`, pilot zamanları `null` …) ağaca
 * ekler. Bu yüzden değişiklik yokken de "kirli" sayılıyordu (kaydedilmiş taslak kalkışta "Discard
 * unsaved changes?" penceresi). Esas alınan alan bazındaki `dirtyFields`'tır: yalnız kullanıcının
 * değiştirdiği (ya da `shouldDirty` ile yazılan) yapraklar `true`'dur.
 */
export function hasDirtyFields(dirty: unknown): boolean {
  if (dirty === true) return true;
  if (Array.isArray(dirty)) return dirty.some(hasDirtyFields);
  if (dirty && typeof dirty === 'object') return Object.values(dirty).some(hasDirtyFields);
  return false;
}
